module.exports = __webpack_public_path__ + "img/rowerhub-dark-logo.fd6b9756.png";